import React from "react";
import { createUseStyles } from "react-jss";

const useStyles = createUseStyles(theme => ({
  input: {
    resize: "vertical",
    border: 0,
    "border-radius": theme.borderRadius,
    "background-color": theme.colorDarkGrey,
    padding: "10px",
    width: "100%",
    "box-sizing": "border-box",
    margin: "10px 0",
    color: theme.textColor,
    "min-height": "120px",
    "font-family": "inherit",
    "font-size": "inherit",
  },
  captial: {
    "text-transform": "capitalize",
  },
}));

const TextArea = ({ placeholder, value, onChange, name }) => {
  const classes = useStyles();

  return (
    <textarea
      name={name}
      className={classes.input}
      placeholder={placeholder}
      value={value}
      onChange={e => {
        onChange(e.target.value);
      }}
    />
  );
};

export default TextArea;
